import { render } from "./ComprasRecibir.vue?vue&type=template&id=104b6082&scoped=true"
import script from "./ComprasRecibir.vue?vue&type=script&lang=js"
export * from "./ComprasRecibir.vue?vue&type=script&lang=js"

import "./ComprasRecibir.vue?vue&type=style&index=0&id=104b6082&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104b6082"]])

export default __exports__